import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "spinner",
    viewBox: "0 0 50 50"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    "stroke-width": "5"
}, null, -1 /* HOISTED */);
const _hoisted_3 = [
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3));
}
